export const authApi = api => ({
  login(email, password) {
    return api.post('/admin/login', {
      email,
      password
    });
  }
});
